import { createAction, props } from '@ngrx/store';
import { RolePermissionPayload, ListRolePermissionResponse, RolePermission, RolePermissionResponse, UpdateRoleParams, ListRolesRequest, RoleNameListResponse, AllModulePermissionsResponse, SystemRolePermission, AssignedRoleCountResponse } from '../../models/rolePermission.model';
import { WritableSignal } from '@angular/core';

const loadRolePermission = createAction(
  '[Role Permission] Load',
  props<{ roleId: number }>()
);

const loadRolePermissionSuccess = createAction(
  '[Role Permission] Load Success',
  props<{ rolePermission: RolePermissionResponse['data'] }>()
);

const loadRolePermissionFailure = createAction(
  '[Role Permission] Load Failure',
  props<{ error: string | null }>()
);

// Create Role
export const createRolePermission = createAction(
  '[RolePermission] Create Role Permission',
  props<{ payload: RolePermissionPayload }>()
);
export const createRolePermissionSuccess = createAction(
  '[RolePermission] Create Role Permission Success',
  props<{ role: RolePermission }>()
);
export const createRolePermissionFailure = createAction(
  '[RolePermission] Create Role Permission Failure',
  props<{ error: string }>()
);

// List Roles
export const listRolePermissions = createAction(
  '[RolePermission] List Roles Permission',
  // props<{ payload?: ListRolePayload }>()
);

export const listRolePermissionsSuccess = createAction(
  '[RolePermission] List Roles Permission Success',
  props<{ response: ListRolePermissionResponse }>()
);

export const listRolePermissionsFailure = createAction(
  '[RolePermission] List Roles Permission Failure',
  props<{ error: string }>()
);

// List System Roles
export const listSystemRolePermissions = createAction(
  '[RolePermission] List System Roles Permission',
  // props<{ payload?: ListRolePayload }>()
);

export const listSystemRolePermissionsSuccess = createAction(
  '[RolePermission] List System Roles Permission Success',
  props<{ response: SystemRolePermission }>()
);

export const listSystemRolePermissionsFailure = createAction(
  '[RolePermission] List System Roles Permission Failure',
  props<{ error: string }>()
);

// Roles Names
export const roleNameList = createAction(
  '[RolePermission] Role Name List',
  // props<{ payload?: ListRolePayload }>()
);

export const roleNameListSuccess = createAction(
  '[RolePermission] Role Name List Success',
  props<{ response: RoleNameListResponse }>()
);

export const roleNameListFailure = createAction(
  '[RolePermission] Role Name List Failure',
  props<{ error: string }>()
);

// Select current Role
export const selectCurrentRolePermission = createAction(
  '[RolePermission] Selct Current Role Permission',
  props<{ id: number }>()
);

export const selectCurrentRolePermissionSuccess = createAction(
  '[RolePermission] Select Current Role Permission Success',
  props<{ role: RolePermission }>()
);

export const selectCurrentRolePermissionFailure = createAction(
  '[RolePermission] Select Current Role Permission Failure',
  props<{ error: string }>()
);

// Clear current Role
export const clearCurrentRolePermission = createAction(
  '[RolePermission] Clear Current Role Permission'
);

// Update Role
export const updateRolePermission = createAction(
  '[RolePermission] Update Role Permission',
  props<{ params: UpdateRoleParams; closeModalSignal: WritableSignal<boolean> }>() // Changed to use params object
);

export const updateRolePermissionSuccess = createAction(
  '[RolePermission] Update Role Permission Success',
  props<{ role: RolePermission }>()
);

export const updateRolePermissionFailure = createAction(
  '[RolePermission] Update Role Permission Failure',
  props<{ error: string }>()
);

// Delete Role
export const deleteRolePermission = createAction(
  '[RolePermission] Delete Role Permission',
  props<{ id: number; closeModalSignal: WritableSignal<boolean> }>()
);

export const deleteRolePermissionSuccess = createAction(
  '[RolePermission] Delete Role Permission Success',
  props<{ id: number }>()
);

export const deleteRolePermissionFailure = createAction(
  '[RolePermission] Delete Role Permission Failure',
  props<{ error: string }>()
);

// module wise permission
export const allModulePermissions = createAction(
  '[RolePermission] All Module wise permissions',
  // props<{ payload?: ListRolePayload }>()
);

export const allModulePermissionsSuccess = createAction(
  '[RolePermission] All Module wise permissions Success',
  props<{ response: AllModulePermissionsResponse }>()
);

export const allModulePermissionsFailure = createAction(
  '[RolePermission] All Module wise permissions Failure',
  props<{ error: string }>()
);

// Check assigned role count
export const checkAssignedRoleCount = createAction(
  '[RolePermission] Assigned Role count',
  props<{ id: number }>()
);

export const checkAssignedRoleCountSuccess = createAction(
  '[RolePermission] Assigned Role count Success',
  props<{ response: AssignedRoleCountResponse }>()
);

export const checkAssignedRoleCountFailure = createAction(
  '[RolePermission] Assigned Role count Failure',
  props<{ error: string }>()
);

const setRoleQueryParams = createAction(
  '[Client] Set Query Params',
  props<ListRolesRequest>()
);

export const RolePermissionActions = {
  loadRolePermission,
  loadRolePermissionSuccess,
  loadRolePermissionFailure,
  createRolePermission,
  createRolePermissionSuccess,
  createRolePermissionFailure,
  listRolePermissions,
  listRolePermissionsSuccess,
  listRolePermissionsFailure,
  listSystemRolePermissions,
  listSystemRolePermissionsSuccess,
  listSystemRolePermissionsFailure,
  roleNameList,
  roleNameListSuccess,
  roleNameListFailure,
  selectCurrentRolePermission,
  selectCurrentRolePermissionSuccess,
  selectCurrentRolePermissionFailure,
  clearCurrentRolePermission,
  updateRolePermission,
  updateRolePermissionSuccess,
  updateRolePermissionFailure,
  deleteRolePermission,
  deleteRolePermissionSuccess,
  deleteRolePermissionFailure,
  allModulePermissions,
  allModulePermissionsSuccess,
  allModulePermissionsFailure,
  checkAssignedRoleCount,
  checkAssignedRoleCountSuccess,
  checkAssignedRoleCountFailure,
  setRoleQueryParams
};
